import React, {useEffect,useState} from 'react';
import {Link} from 'react-router-dom'
import InputMask from "react-input-mask";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import {Input} from '../components/Input'
import {api,up,Button,ApiDataTa} from "../Run"
import { saveAs } from 'file-saver';
import Address from "../components/common/Address";

import Surname from "../components/common/Surname";

import Name from "../components/common/Name";

import Patron from "../components/common/Patron";

import Logo from '../images/logo2.svg'

import style from '../components/common/Adress.module.css';


function Opd() {

    let today = new Date();
    let year = today.getFullYear();
    let day = ('0' + today.getDate()).slice(-2);
    let month = ('0' + (today.getMonth()+1)).slice(-2);

    let [input, setInput] = useState({
        passOrgList:[],
        passOrgListCode:[],
        PDConsentDate: year + '-' + month+ '-' + day ,
        type:1,
        PDConsentCancelDate:year + '-' + month+ '-' + day,
        "pagePass":"ru",
        "typeDoc":"",
        "FirstName":"",
        "MidName":"",
        'loginEmail':'',
        "LastName":"",
        "bdate":"",
        "inn":"",
        "snils":"",
        "telMob":"",
        "email":"",
        "telHome":"",
        "passNo":"",
        "passSer":"",
        "passDate":"",
        "passOrg":"",
        'passDeptCode':'',
        "AddressReg":"",
        "bPlace": "",
    })

    let [error,setError] = useState({error:false, msg:'',title:'', errors:false})

    let [page,setPage] = useState({print:false})

    let [data,setData] = useState({})

    let [button, setButton] = useState({login:false,print:false,up:false})


    let [foc,setFoc] = useState({
        inn:false,
        ogrn:false,
        web:false,
        okpo:false,
        tel:false,
        dataReg:false,
        start:false,
        col:false,
        pass:false,
        kod:false,
        addressPass:false,
        nameU:false,
        disGk:false,
        viewDe:false,
        nameAndInn:false,
        infoDoc:false,
        nameKre:false,
        dataEnd:false,
        ros:false,
        nameBank:false
    })


    let change = (e) => {
        setInput(input => ({...input, [e.target.name]: e.target.value}))
        if (e.target.name === "passDeptCode") {
            ApiDataTa(e.target.value).then((d) => {
                if (d.suggestions.length > 0) {
                    console.log(d.suggestions);
                    setInput(input => ({...input, passOrgListCode: d.suggestions}))
                }
            })
        }

        if (e.target.name === "passOrg") {
            ApiDataTa(e.target.value).then((d) => {
                if (d.suggestions.length > 0) {
                    console.log(d.suggestions);
                    setInput(input => ({...input, passOrgList: d.suggestions}))
                }
            })
        }
        e.persist()
    }

    let codeOrg = (d, code) => {
        setInput(input => ({...input, passOrgList: [],passOrg: d,passDeptCode:code}))
    }

    let params = (new URL(document.location)).searchParams;

    let [root,setRoot] = useState(false)


    let opd = (e) => {
        setButton(button => ({...button, login:true}))
        api('temprepeal',{linkCode:params.get("linkCode"),email:input.loginEmail}).then((d) => {
            console.log(d);
            if(d.Error) {
                setError(error => ({...error, error:true, msg: d.Error, title: d.title}))
            } else if(d.error) {
                setError(error => ({...error, error:true, msg: d.error.error, title: 'Внимание!'}))
            } else {
                setError(error => ({...error, error:false, msg: '' ,title: ''}))
                delete d.Get;

                let newPassDate = new Date(d.passDate);
                let newBdate = new Date(d.bdate);
                setInput(input => ({...input,...d,passOrgList:[],
                    telMob: "(911)600-55-60",
                    serno: d.serno ? d.serno : d.passSer +' '+ d.passNo,
                    passDate: newPassDate ? newPassDate.getFullYear()+'-'+('0' + (newPassDate.getMonth()+1)).slice(-2)+'-'+('0' + newPassDate.getDate()).slice(-2) : '' ,
                    bdate: newBdate? newBdate.getFullYear()+'-'+('0' + (newBdate.getMonth()+1)).slice(-2)+'-'+('0' + newBdate.getDate()).slice(-2) : '' ,
                    PDConsentDate: d.PDConsentDate ? d.PDConsentDate :  year + '-' + month+ '-' + day ,type:1,linkCode:params.get("linkCode")}))
                console.log(input);
                console.log();
                setRoot(true)
            }
            setButton(button => ({...button, login:false}))
        })
        e.preventDefault()
    }

    let print = (e) => {


        let gg = new Date(input.passDate).getTime();
        let ff = new Date().setYear(new Date().getFullYear()-35);
        let uu = + new Date();
        setError(error => ({...error, error:false, msg: '', title: ''}))
        e.preventDefault()

        if (ff <= gg && gg <= uu) {


            setButton(button => ({...button, print:true}))
        setError(error => ({...error, error:false, msg: '', title: '', errors: false}))
   


        setTimeout(function () {
            setTimeout(function () {
                // window.scrollTo(0, 0)
                api('test',{Put:'PDConsentCancelEdit',...input,"action":"Create"}).then((d) => {


                    if (d.data.error) {
                        if (d.data.error.errors) {
                            setError(error => ({...error, error:true, msg: d.data.error.error,title: 'Внимание!', errors: d.data.error.errors}))
                        } else {
                            setError(error => ({...error, error:true, msg: d.data.error.error, title: 'Внимание!'}))
                        }
                        setButton(button => ({...button, print:false}))

                    } else {
                        var win = document.getElementById("test").contentWindow;
        win.postMessage({...input,qr:d.data.QRCodeImg});

        setTimeout(function () {
        var frm = document.getElementById('test').contentWindow;
        frm.print();
        setPage(page => ({...page,print:true}))
        // setButton(button => ({...button, print:false}))
    }, 200);

                    }

                    setButton(button => ({...button, print:false}))
                })
              }, 0);
            }, 200);






        } else {
            setError(error => ({...error, error:true, msg: 'Ошибка даты выдачи паспорта', title: 'Внимание!'}))
            setButton(button => ({...button, print:false}))
        }


        
        // e.preventDefault()
    }


    let save = (e) => {


        console.log(input.telMob);

        let gg = new Date(input.passDate).getTime();
        let ff = new Date().setYear(new Date().getFullYear()-35);
        let uu = + new Date();

        e.preventDefault()

        if (ff <= gg && gg <= uu) {


            setButton(button => ({...button, print:true}))
        setError(error => ({...error, error:false, msg: '', title: ''}))


                api('test',{Put:'PDConsentEdit',...{...input, telMob:'+'+chTel(input.telMob)},"action":"Create"}).then((d) => {


                    if (d.data.error) {
                        if (d.data.error.errors) {
                            setError(error => ({...error, error:true, msg: d.data.error.error,title: 'Внимание!', errors: d.data.error.errors}))
                        } else {
                            setError(error => ({...error, error:true, msg: d.data.error.error, title: 'Внимание!'}))
                        }
                        setButton(button => ({...button, print:false}))

                    } else {

                        setError(error => ({...error, error:true, msg: d.data.msg, title: 'Внимание!'}))
                        setPage(page => ({...page,print:true}))
                    }

                    setButton(button => ({...button, print:false}))
                   
                })
    




        } else {
            setError(error => ({...error, error:true, msg: 'Ошибка даты выдачи паспорта', title: 'Внимание!'}))
            setButton(button => ({...button, print:false}))

        }


        
        // e.preventDefault()
    }



    let dow = (e) => {
        setButton(button => ({...button, dow:true}))
        setTimeout(function () {
            setTimeout(function () {
                // window.scrollTo(0, 0)
                api('test',{Put:'PDConsentEdit',...input,"action":"Create"}).then((d) => {
                    var win = document.getElementById("test").contentWindow;
                    win.postMessage({...input,qr:d.data.QRCodeImg});
                    if (d.data.error) {
                        setError(error => ({...error, errors: d.data.error}))
                        setButton(button => ({...button, dow:false}))
                    } else {

                        setTimeout(function () {
                        var frm = document.getElementById('test').contentWindow;


                        var FileSaver = require('file-saver');
                        var blob = new Blob([frm.document.getElementsByTagName('html')[0].innerHTML], {type: "text/plain;charset=utf-8"});
                        FileSaver.saveAs(blob, "opd.doc");
                        setButton(button => ({...button, dow:false}))

                    }, 200);

                    }
                })
              }, 0);
            }, 200);

        e.preventDefault()
    }




    let rrr = (e) => {
        
        

        let gg = new Date(input.passDate).getTime();
        let ff = new Date().setYear(new Date().getFullYear()-35);
        let uu = + new Date();

        e.preventDefault()

        if (ff <= gg && gg <= uu) {

            document.getElementById('my_file').click();




} else {
setError(error => ({...error, error:true, msg: 'Ошибка даты выдачи паспорта', title: 'Внимание!'}))
setButton(button => ({...button, print:false}))

}
    }


    let upload = (e) => {



        setError(error => ({...error,errorFile:''}))


        setButton(button => ({...button, up:true}))
        // const file = e.target.files[0];
        // let formData = new FormData();
        // formData.append('file', file);

        //                 up('ul',formData).then((d) => {
        //             console.log(d);
        //         })
        let file = e.target.files
        let temp = [];

        if (file) {

        //     let formData = new FormData();
        //     formData.append('file', file[0])

        //         api('ul',{linkCode:params.get("linkCode"),file:formData}).then((d) => {
        //             console.log(d);
        //         })

        for (let index = 0; index < file.length; index++) {

            setError(error => ({...error, error:false, msg: '', title: 'Внимание!'}))
            let reader = new FileReader()
            reader.readAsDataURL(file[index])
            reader.onload = () => {

                temp = [...temp,{file:reader.result,name:file[index].name}]


                // api('ul',{linkCode:params.get("linkCode"),file:reader.result,type:file.name.match(/\.[0-9a-z]+$/i)[0]}).then((d) => {
 if ((index+1) === file.length) {
             api('upload',{AppLeasingId:0,files:temp,linkCode:params.get("linkCode")}).then((d) => {

                document.getElementById('my_file').value = "";

                if (d.error) {
                    setError(error => ({...error,errorFile:d.error}))
                } else {
                    setData(data => ({...data, file:true, fileUrl:d.url}))
                    setButton(button => ({...button, up:false}))

                    if (input.type === 1) {
                        api('test',{Put:'PDConsentCancelEdit',"action":"LoadScan","linkCode":params.get("linkCode"),"files":[d.url]}).then((d) => {
                            console.log(d);
                            if (d.data.error) {
                                setError(error => ({...error, error:true, msg: d.data.error.error, title: 'Внимание!'}))
                            }  else {
                                setError(error => ({...error,errorFile:d.data.msg ? d.data.msg :'Документ отправлен менеджеру, после рассмотрения с Вами свяжутся'}))
                            }

                            console.log(d.data.error);
                        })
                    } else {
                        setError(error => ({...error,errorFile:''}))
                        api('test',{Put:'PDConsentCancelEdit',"action":"LoadDocESign","linkCode":params.get("linkCode"),"files":[d.url]}).then((d) => {
                            console.log(d);
                            if (d.data.error) {
                                setError(error => ({...error,errors:d.data.error}))
                            } else {
                                setError(error => ({...error,errorFile:d.data.msg ? d.data.msg :'Документ отправлен менеджеру, после рассмотрения с Вами свяжутся'}))
                            }
                        })
                    }
                }
                  


                })}

            }
}
        //     console.log(file);
        } else {
            setButton(button => ({...button, up:false}))
        }












    }


    let chTel = (t) => {

        if (t) {
            t = t.replace(/[^\d]/g, '')

            if (t.length == 11) {
                if (t.toString()[0] !== 7) {
                    t = 7+t.slice(1)
                    t = t.substr(0, 1) + '('+t.substr(1, 3) +')'+t.substr(4, 3) +'-'+t.substr(7, 2) +'-'+t.substr(9, 2)
                    return t
                } else {
                    t = t.substr(0, 1) + '('+t.substr(1, 3) +')'+t.substr(4, 3) +'-'+t.substr(7, 2) +'-'+t.substr(9, 2)
                    return t
                }
            } else  if (t.length <= 11){
                if (t.toString()[0] != 7) {
                    t = 7+t
                    t = t.substr(0, 1) + '('+t.substr(1, 3) +')'+t.substr(4, 3) +'-'+t.substr(7, 2) +'-'+t.substr(9, 2)
                    return t
                } else {
                    t = t.substr(0, 1) + '('+t.substr(1, 3) +')'+t.substr(4, 3) +'-'+t.substr(7, 2) +'-'+t.substr(9, 2)
                    return t
                }
            } else {
                return ''
            }

        } else {
            return ''
        }


    }


    const onChangeAddress = (value) => {
        setInput(input => ({...input, AddressReg: value}))
    }


    const onChangeSurname = (value) => {
        setInput(input => ({...input, LastName: value}))
    }

    const onChangeName = (value) => {
        setInput(input => ({...input, FirstName: value}))
    }

    const onChangePatron = (value) => {
        setInput(input => ({...input, MidName: value}))
    }

    const onBlur = () => {
        setTimeout(() => {
            setInput(input => ({...input, passOrgList: [], passOrgListCode: []}))
        }, 200);

    }



    return <>





    <div class="content-page">
				<div class="content-main">


   
                <div class="page-head mb-4">Отзыв согласия на обработку персональных данных</div>
<div class="row">
{root ? <> <div class="col-lg-5 col-md-8"><form onSubmit={save}>
	
        <Surname
                            value={input.LastName}
                            name='LastName'
                            onChange={onChangeSurname}
                            tooltipText='Фамилия'
                            label='Фамилия'
                            className='form-control'
                            autoComplete='off'
                        />
                        
		<div class="row">
			<div class="col-md-6">
				{/* <div class="form-group mb-3 form-floating">
					<input class="form-control" placeholder="Иванов" name="FirstName" value={input.FirstName} onChange={change} />
					<label>Имя</label>
				</div> */}

<Name
                            value={input.FirstName}
                            name='FirstName'
                            onChange={onChangeName}
                            tooltipText='Имя'
                            label='Имя'
                            className='form-control'
                            autoComplete='off'
                        />
			</div>
			<div class="col-md-6">
				{/* <div class="form-group mb-3 form-floating">
					<input class="form-control" placeholder="Иванов" name="MidName" value={input.MidName} onChange={change} />
					<label>Отчество</label>
				</div> */}
                <Patron
                            value={input.MidName}
                            name='MidName'
                            onChange={onChangePatron}
                            tooltipText='Отчество'
                            label='Отчество'
                            className='form-control'
                            autoComplete='off'
                        />
			</div>
		</div>
		<h6 class="mt-4">Паспорт</h6>
		<hr size="2" />
		<div class="form-group mb-3 form-floating">
        <InputMask mask="9999 999999" name="serno" class="form-control"  onFocus={()=>setFoc(foc => ({...foc, pass:true}))}  onBlur={()=>setFoc(foc => ({...foc, pass:false}))}  onChange={change}  value={input.serno} type="text"  />
			{/* <input class="form-control" placeholder="Иванов" /> */}
			<label>Серия и номер паспорта</label>
		</div>
		<div class="form-group mb-3 form-floating">
			<input class="form-control" placeholder="Иванов" name="passOrg" autoComplete='off'  onBlur={onBlur} value={input.passOrg} onChange={change} />
			<label>Место выдачи</label>
		</div>
        {input.passOrgList.length > 0 && <div className={style.dropDown}>{input.passOrgList.map((d,i)=> {
                return <div key={i} onClick={()=>codeOrg(d.value,d.data.code)} className={style.dropDown__item} >{d.value}</div>
            })}</div>}
		<div class="row">
			<div class="col-md-6">
				<div class="form-group mb-3 form-floating">
					<input class="form-control" placeholder="Иванов" name="passDate" value={input.passDate} onChange={change} max="2999-12-31" type="date" />
					<label>Дата выдачи</label>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group mb-3 form-floating">
					{/* <input class="form-control" placeholder="Иванов" value="Иванович" /> */}
                    <InputMask class="form-control" mask="999-999" name='passDeptCode' value={input.passDeptCode} autoComplete='off' onBlur={onBlur}  onChange={change} type="text"  />
					<label>Код подразделения</label>
				</div>
                {input.passOrgListCode.length > 0 && <div className={style.dropDown}>{input.passOrgListCode.map((d,i)=> {
                return <div key={i} onClick={()=>codeOrg(d.value,d.data.code)} className={style.dropDown__item} >{d.value}</div>
            })}</div>}
			</div>

           



		</div>
		
			{/* <input class="form-control" placeholder="ИвpassDateанов" /> */}
			{/* <label>Адрес регистрации</label> */}
            <Address
                            value={input.AddressReg}
                            name='AddressReg'
                            onChange={onChangeAddress}
                            tooltipText='Адрес постоянной регистрации, указанный в паспорте'
                            label='Адрес регистрации (по паспорту)'
                            className='form-control'
                            autoComplete='off'
                        />


<div class="form-group mb-3 form-floating" >
<textarea class="form-control" rows="3" style={{height:'100px'}} onChange={change} name='Reason'>{input.Reason}</textarea>
					<label>Причина отзыва</label>
				</div>

                <div class="col-md-6">
				<div class="form-group mb-3 form-floating">
					<input class="form-control" placeholder="Иванов" name="PDConsentCancelDate" value={input.PDConsentCancelDate} onChange={change} max="2999-12-31" type="date" />
					<label>Дата прекращения</label>
				</div>
			</div>

		<div class="mt-4">

        {error.error && <div className='login-alert p-3 text-center mb-3'><div className='text-primary'>{error.title}</div>{error.msg}</div>}
                    {error.errors && <div className='login-alert p-3 text-center mb-3'><div className='text-primary'>{error.error}</div>
                    <div style={{textAlign:'left'}}><ul >{error.errors.map((d,i)=>{
                            return <li key={i}>{d.text}</li>
                        })}</ul>
                        </div>
                    </div>}

            <button className="btn btn-ref d-flex align-items-center line-height-1_2 mb-4" onClick={print}><i class="icon-print me-2"></i>Распечатать</button>

            {error.errorFile && <div className='login-alert p-3 text-center mb-3 mt-3'><div className='text-primary'>Внимание!</div>{error.errorFile}
                        </div>}

			<div class="row mt-4">
				<div class="col-auto mb-4"><button className="btn btn-base" disabled>Загрузить с ЭЦП</button></div>
                <input type="file" id="my_file" onChange={upload}  multiple />
				<div class="col-auto mb-4"><button type='button' className="btn btn-base" onClick={rrr}>Загрузить с обычной подписью</button></div>
			</div>
		</div>
        <div class="mt-3">* ВНИМАНИЕ! Сохраняйте оригинал документа.</div>
        </form>
	</div></> : <div class="col-lg-5 col-md-8">
        {error.error && <div className='login-alert p-3 text-center mb-3'><div className='text-primary'>{error.title}</div>{error.msg}</div>}
        <div class="form-group mb-3 form-floating">
            <input class="form-control" name="loginEmail" onChange={change} value={input.loginEmail} placeholder="Иванов" />
            <label>E-mail или Фамилия</label>
        </div>

        <div class="mt-4">
            <button class="btn btn-base" onClick={opd} disabled={button.login}><Button title='Продолжить' color='btn-black-base' param={button.login} /></button>
		</div>
    </div>}



	<div class="col-lg-7 col-md-8">
		<p>Настоящим я (Пользователь), во исполнение требований законодательства о персональных данных, а также законодательства о рекламе, действуя свободно, своей волей и в своем интересе даю своё согласие Обществу с ограниченной ответственностью «Лизинговая компания «СТОУН-XXI» (далее – ООО «СТОУН-XXI») (ОГРН 1027739641710, ИНН 7710329843), с местом нахождения: Российская Федерация, 123056, г. Москва, Малый Тишинский пер. д.14-16, почтовым адресом Российская Федерация, 117105, г. Москва, ул. Нагатинская, д. 1, на обработку своих персональных данных, указанных при регистрации и/или оставлении заявки на получение расчета лизинга и/или на получение рекламной информации, связанной с договором лизинга и лизинговой деятельностью (включая рекламу) по любым каналам связи, включая: SMS-оповещение, почтовое письмо, телеграмму, голосовое сообщение (далее – Рассылка) путем заполнения веб-формы на сайте ООО «СТОУН-XXI» (https://www.stone-xxi.ru/) (далее – «Сайт»).</p>
		<hr size="2" />
		<h6 class="mt-4">Что такое персональные данные</h6>
		<p>Под персональными данными понимается любая информация, относящаяся ко мне как к субъекту персональных данных, в том числе:</p>
		<div class="row">
			<div class="col-lg-4">
				<ul>
					<li class="mb-1">фамилия, имя, отчество,</li>
					<li class="mb-1">дата и место рождения,</li>
					<li class="mb-1">гражданство,</li>
					<li class="mb-1">пол,</li>
					<li class="mb-1">место работы и должность,</li>
					<li class="mb-1">почтовый адрес;</li>
					<li class="mb-1">номера рабочего и мобильного телефонов,</li>
					<li class="mb-1">адреса электронной почты,</li>
				</ul>
			</div>
			<div class="col-lg-4">
				<ul>
					<li class="mb-1">данные водительского удостоверения,</li>
					<li class="mb-1">адрес регистрации по месту жительства,</li>
					<li class="mb-1">адрес фактического проживания,</li>
					<li class="mb-1">паспортные данные,</li>
					<li class="mb-1">данные, которые относятся (могут быть отнесены) к категории биометрические персональные данные,</li>
				</ul>
			</div>
			<div class="col-lg-4">
				<ul>
					<li class="mb-1">идентификационный номер налогоплательщика,</li>
					<li class="mb-1">номер страхового свидетельства обязательного пенсионного страхования,</li>
					<li class="mb-1">иные персональные данные, в том числе полученные посредством заполнения заявки расчета лизинга на Сайте.</li>
				</ul>
			</div>
		</div>
		<hr size="2" />
		<h6 class="mt-4">Цели сбора и обработки персональных данных</h6>
		<p>Целями обработки, в том числе целями сбора, персональных данных являются: определение возможности заключения договоров лизинга, договоров страхования (страховых полисов), договоров купли-продажи, любых иных договоров, необходимых для реализации договора лизинга, их заключения, изменения, исполнения и прекращения, продвижения лизинговых и иных услуг посредством любых средств связи, а также для обеспечения соблюдения законов и иных нормативно-правовых актов.</p>
		<hr size="2" />
		<h6 class="mt-4">Соглашение</h6>
		<p>Я согласен (а) с тем, что в рамках обработки персональных данных ООО «СТОУН-XXI» вправе осуществлять сбор, запись, систематизацию, накопление, анализ, использование, извлечение, распространение, передачу любым иным третьим лицам, в том числе и трансграничную передачу, получение, обработку, хранение, уточнение (обновление, изменение), обезличивание, блокирование, удаление, уничтожение моих персональных данных путем ведения баз данных автоматизированным, механическим, ручным способами в целях: ведения и актуализации клиентской базы; получения и исследования статистических данных об объемах продаж и качестве оказываемых услуг; проведения маркетинговых программ; проведения опросов и исследований, направленных на выявление удовлетворенности/неудовлетворенности Пользователя, постоянного совершенствования уровня предоставляемых услуг; информирования меня о предлагаемых ООО «СТОУН-XXI» автомобилях, оказываемых услугах, проводимых бонусных мероприятий, акций и т.д.; рекламирования и иного любого продвижения товаров и услуг на рынке путем осуществления прямых контактов со мной и иными потребителями; технической поддержки при обработке информации и персональных данных с использованием средств автоматизации и без такого использования.</p>
		<p>Я выражаю согласие на получение рекламы и разрешаю ООО «СТОУН-XXI» осуществлять в мой адрес смс-рассылки, а также иные виды рассылок и уведомлений, в том числе рекламного характера, с использованием любых средств связи, в том числе электронной почты.</p>
		<p>Я ознакомлен (а), что: настоящее Согласие на обработку моих персональных данных и получение рекламы действует в течение 20 (двадцати) лет, а в части персональных данных, содержащихся в документах и на иных носителях информации, срок хранения которых по действующему законодательству превышает двадцать лет, Согласие на обработку персональных данных действует в течение сроков хранения таких документов и иных носителей информации, установленных действующим законодательством. Согласие на обработку персональных данных может быть отозвано посредством направления соответствующего письменного уведомления в адрес ООО «СТОУН-XXI» по адресу места нахождения, указанному в настоящем согласии. В этом случае лицо, получившее отзыв согласия на обработку персональных данных или согласия на получение рекламы, прекращает обработку персональных данных, а персональные данные подлежат уничтожению или обезличиванию, если отсутствуют иные правовые основания для обработки, установленные законодательством РФ или документами лица, получившего отзыв согласия на обработку персональных данных, регламентирующими вопросы обработки персональных данных. Настоящее Согласие считается отозванным по истечении 30 (тридцати) дней с момента получения ООО «СТОУН-XXI» письменного уведомления об отзыве настоящего согласия. День получения уведомления не включается в 30-тидневный срок.</p>
		<p>При изменении адресов электронной почты и/или номеров телефонов, по которым осуществляется Рассылка рекламы, я обязуюсь незамедлительно проинформировать об этом ООО «СТОУН-XXI» об изменении адресов электронной почты и/или номеров телефонов. До указанного уведомления Рассылка осуществляется по адресам электронной почты и номерам телефонов, указанным в веб-форме заявки расчета лизинга на Сайте, а риск связанных с этих последствий принимаю на себя.</p>
		<p>Настоящим Согласием я подтверждаю, что являюсь субъектом предоставляемых персональных данных, а также подтверждаю достоверность предоставляемых данных.</p>
		<p>Я осознаю, что, регистрируясь и авторизируясь на Сайте, оставляя заявку на получение расчета лизинга и/или подписываясь на получение рекламной информации на Сайте, я выражаю ООО «СТОУН-XXI» своё письменное согласие с условиями, описанными в настоящем Согласии.</p>
	</div>
</div>
</div>
</div> 



<iframe src='/test2.html' id='test' width='0' height='0'></iframe>
    </>
}

export default Opd
